import { LiteratureReviewPlan } from "@core/domain/models/literature-review-plan.model";
import { BuiltInImportSourceId } from "@core/domain/types/builtInImportSourceId";
import { LevelOfEvidence } from "@core/domain/types/levelOfEvidence.type";

export function generateNotifiedBodySearchQuery(
  importSourceId: string,
  plan: LiteratureReviewPlan,
) {
  if (importSourceId === BuiltInImportSourceId.PUBMED) {
    return generatePubmedMedicalBackgroundSearchQuery(plan);
  }

  return "";
}

function generatePubmedMedicalBackgroundSearchQuery(plan: LiteratureReviewPlan) {
  const loe = plan?.targetLoe;
  const deviceGroupNames = [...(plan?.alternativeDeviceGroupNames ?? []), plan?.deviceGroup];

  const yearsToSubtract = plan?.timeRange ?? 5;
  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(endDate.getFullYear() - yearsToSubtract);

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  const timeRangeQuery = `(${formattedStartDate}:${formattedEndDate}[pdat])`;

  const deviceGroupNamesQuery = `(${deviceGroupNames
    .filter((name) => !!name)
    .map((name) => `"${name}"[Title]`)
    .join(" OR ")})`;

  switch (loe) {
    case LevelOfEvidence.A:
      return `${deviceGroupNamesQuery} AND ("guideline"[Title] OR "Practice Guideline"[Publication Type] OR "Clinical Protocols"[MeSH] OR "Evidence-Based Practice"[MeSH]) AND ${timeRangeQuery}`;
    case LevelOfEvidence.B:
      return `${deviceGroupNamesQuery} AND ("systematic review"[Title] OR "Review Literature as Topic"[MeSH] OR "meta-analysis"[Title] OR "Meta-Analysis"[Publication Type]) AND ${timeRangeQuery}`;
    case LevelOfEvidence.C:
      return `${deviceGroupNamesQuery} AND ("randomized controlled trial"[Publication Type] OR "Randomized Controlled Trials as Topic"[MeSH] OR “random allocation” [MeSH] ) AND ${timeRangeQuery}`;
    case LevelOfEvidence.D:
      return `${deviceGroupNamesQuery} AND ("randomized controlled trial"[Publication Type] OR “cohort studies” [MeSH] OR "Observational Studies as Topic"[MeSH] OR "Case-Control Studies”[MeSH] ) AND ${timeRangeQuery}`;
    case LevelOfEvidence.E:
      return `${deviceGroupNamesQuery} AND (Case Reports[Publication Type])`;
    case LevelOfEvidence.F:
      return `${deviceGroupNamesQuery} AND (Review[Publication Type]) AND ${timeRangeQuery}`;
  }
  return "";
}
